import { Button, styled, Theme } from '@quillbot/design-system';

const CircularGoldButton = styled(Button)<{ featured: number }>`
  && {
    border-radius: 205px;
    font-weight: 600;

    background: ${({ theme, featured }: { theme: Theme; featured: number }) =>
      featured ? theme.palette.secondary.main : theme.palette.primary.main};
    &:hover {
      background: ${({ theme, featured }: { theme: Theme; featured: number }) =>
        featured ? theme.palette.secondary.dark : theme.palette.primary.dark};
    }
  }
`;

export default CircularGoldButton;
